export default __webpack_public_path__ + "static/media/Judicator Arcus.1e483f4e.jpg";